import styled from 'styled-components';

export const PassCodeContainer = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	height: 100vh;
	padding: 16px;
	background: #F2F5F7;
	align-items: center;
	justify-content: space-between;
`;

PassCodeContainer.InfoContainer = styled.div`
	max-width: 800px;
	overflow-y: auto;
	flex-direction: column;
	background: #FFFFFF;
	border-radius: 12px;
`;
